<template>
  <b-card>
    <b-card-title class="mb-1">
      แสดงประเภทสินค้า
    </b-card-title>
    <!-- <b-card-sub-title class="mb-2">
      Spending on various categories
    </b-card-sub-title> -->

    <vue-apex-charts
      type="donut"
      height="350"
      :options="donutChart.chartOptions"
      :series="donutChart.series"
    />
  </b-card>
</template>

<script>
import { BCard, BCardTitle, BCardSubTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import apexChatData from "./apexChartData";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardSubTitle,
  },
  data() {
    return {
      donutChart: {
        series: [],
        chartOptions: {
          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: ["#FFA1A1", "#ffe700", "#826bf8", "#2b9bf4"],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`;
                    },
                  },
                  total: {
                    show: true,
                    fontSize: "1.5rem",
                    label: "ประเภทสินค้า",
                    formatter() {
                      return "100%";
                    },
                  },
                },
              },
            },
          },
          labels: [],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.getReportProductCategory();
  },
  methods: {
    getReportProductCategory() {
      store
        .dispatch("dashboard-seller/getReportProductCategory")
        .then((response) => {
          response.data.data.map((item) => {
            this.donutChart.series.push(item.categorySummary);

            if (item.categoryName) {
              this.donutChart.chartOptions.labels.push(item.categoryName);
            } else {
              this.donutChart.chartOptions.labels.push("ไม่ระบุ");
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
